import { FC } from 'react';
import { Box } from '../../../Box';

import styles from './index.module.css';

interface TrackProps {
  source: {
    id: string;
    value: number;
    percent: number;
  };
  target: {
    id: string;
    value: number;
    percent: number;
  };
  getTrackProps: () => Record<string, unknown>;
  disabled?: boolean;
}

export const Track: FC<TrackProps> = ({ source, target, getTrackProps }) => (
  <Box
    className={styles.track}
    style={{
      left: `${source.percent}%`,
      width: `${target.percent - source.percent}%`
    }}
    {...getTrackProps()}
  />
);
